<script>
    import {onDestroy, createEventDispatcher, tick} from 'svelte';
    import {youTubeInitialized} from "./Utils/youtubeStore";
    import {videoPlaybackStore} from "./stores/videoPlaybackStore";

    const dispatch = createEventDispatcher();
    export let video;

    const vid_element_id = 'yt_video_element';
    const lang = 'en';
    let yt_player = null;

    export function set_player_time(settime) {
        if (yt_player) {
            yt_player.seekTo(settime);
        } else {
            console.error('YT Player not initialised');
        }
    }

    function get_youtube_link(avideo) {
        if (!avideo || !avideo.youtube) {
            return "";
        }
        let subtitles = '';
        if (lang.toLowerCase() == 'en') {
            subtitles = `&cc_load_policy=1&cc_lang_pref=${lang}`
        }
        return `https://www.youtube.com/embed/${avideo.youtube.id}?enablejsapi=1${subtitles}`;
    }


    function calculateDurationInSeconds(video) {
        if (!video || !video.duration) {
            return 0
        }
        return video.duration.minutes * 60 + video.duration.seconds;
    }

    $: durationInSeconds = calculateDurationInSeconds(video);


    function checkForSoftFinish(time) {
        if (video.videoDuration != null) {
            let totalvideomins = video.videoDuration.minutes * 60;
            let totalvideotime = totalvideomins + video.videoDuration.seconds;

            if (totalvideotime > 1) {
                if ((totalvideotime - time) < 20) {
                    dispatch('soft-video-end');
                }
            }
        }
    }

    const unsubscribe = videoPlaybackStore.subscribe((time) => {
        checkForSoftFinish(time);
    })


    let pollingId = null

    function update_current_time() {
        if (yt_player) {
            // console.log(yt_player.getCurrentTime())
            $videoPlaybackStore = yt_player.getCurrentTime();
        }
        pollingId = setTimeout(update_current_time, 5000)
        return pollingId;
    }

    function on_player_ready() {
        pollingId = update_current_time()
    }

    function on_player_state_change(e) {
        if (e.data === 0) { // video ended
            dispatch('video-ended');
        }
    }

    function init_yt_player() {
        if ($youTubeInitialized) {
            yt_player = new YT.Player(vid_element_id, {
                events: {
                    'onReady': on_player_ready,
                    'onStateChange': on_player_state_change
                }
            });
        } else {
            console.warn("YT not initialized");
        }
    }

    function on_video_tag_created() {
        init_yt_player();
        return {
            update(video) {
                init_yt_player();
            }
        }
    }

    const unsubscribePlayer = youTubeInitialized.subscribe(value => {
        init_yt_player();
    })

    onDestroy(() => {
        unsubscribePlayer();
        unsubscribe();
        if (pollingId != null) {
            clearTimeout(pollingId)
        }
    })

</script>
<div class="videowrapper">
    <iframe
            id={vid_element_id}
            width="100%"
            height="100%"
            src={get_youtube_link(video)}
            title={video.videoTitle}
            frameborder="0" allowfullscreen
            use:on_video_tag_created
    />
</div>
<style>
    .videowrapper {
        float: none;
        clear: both;
        width: 100%;
        position: relative;
        padding-bottom: 56.25%;
        height: 0;
    }

    .videowrapper iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>
